import { IConfiguration } from "../models/configuration/plugin/IConfiguration";
import { deepEqual } from "./deepEqual";

const normalizeConfig = (config?: IConfiguration | null): Record<string, unknown> | null => {
    if (!config) return null;
    const { LastUpdateUtc, ...rest } = config as IConfiguration & Record<string, unknown>;
    return rest;
};


export const hasPluginConfigChanges = (
    current: IConfiguration,
    persisted?: IConfiguration | null
): boolean => {
    if (!persisted) return true;
    return !deepEqual(normalizeConfig(current), normalizeConfig(persisted));
};
